import Coupon from '../Coupon.vue'
import CouponTable from '../Views/CouponsTable.vue'
import CouponCreate from '../Views/CouponsCreate.vue'
import CouponUpdate from '../Views/CouponsUpdate.vue'
import CouponDetail from '../Views/CouponsDetail.vue'

const discountCouponsRoutes = {
  path: '/coupons',
  meta: {
    name: {
      es: 'Cupones de Descuento',
      en: 'Coupons Discount'
    }
  },
  component: Coupon,
  children: [
    {
      path: '',
      component: CouponTable,
      meta: { name: 'Index', group: 'portaladministrativo.prices', path: 'discountCoupons', permission: 'READ' }
    },
    {
      path: 'create',
      component: CouponCreate,
      meta: { name: 'DiscountCouponsCreate', group: 'portaladministrativo.prices', path: 'discountCoupons', permission: 'CREATE' }
    },
    {
      path: 'update/:id',
      component: CouponUpdate,
      meta: { name: 'DiscountCouponsUpdate', group: 'portaladministrativo.prices', path: 'discountCoupons', permission: 'UPDATE' }
    },
    {
      path: 'details/:id',
      component: CouponDetail,
      meta: { name: 'DiscountCouponsDetail', group: 'portaladministrativo.prices', path: 'discountCoupons', permission: 'UPDATE' }
    },
  ]
}

export default discountCouponsRoutes
